import { create } from "zustand";
import { persist } from "zustand/middleware";

interface SidebarStore {
  workflowExpanded: boolean;
  setWorkflowExpanded: (expanded: boolean) => void;
  pluginsExpanded: boolean;
  setPluginsExpanded: (expanded: boolean) => void;
}

export const useSidebarStore = create<SidebarStore>()(
  persist(
    set => ({
      workflowExpanded: true, // Start with workflow section expanded
      setWorkflowExpanded: (expanded: boolean) => set({ workflowExpanded: expanded }),
      pluginsExpanded: false, // Start with plugins section collapsed
      setPluginsExpanded: (expanded: boolean) => set({ pluginsExpanded: expanded }),
    }),
    {
      name: "sidebar-storage", // unique name for localStorage key
    },
  ),
);
